import { flexRender } from '@/lib/tanstack-table';
import {
  ITEM_COLUMN_IDS,
  type LineCell,
  type LineCellContext,
} from './needRowsContext';
import { SoLineLabel } from './SoLineLabel';

export function SoRowCell({
  context,
  base,
}: {
  context: LineCellContext;
  base: LineCell;
}) {
  if (context.column.id === 'product') {
    return <SoLineLabel line={context.row.original} />;
  }
  if (ITEM_COLUMN_IDS.has(context.column.id)) return null;
  return flexRender(base, context);
}
